import React, { useState, createContext, useEffect } from 'react';

// Crear el contexto
export const CartContext = createContext();
const CART_STORAGE_KEY = 'esganga-cart';

function loadStoredCart() {
    try {
        const stored = JSON.parse(localStorage.getItem(CART_STORAGE_KEY) || '[]');
        return Array.isArray(stored) ? stored : [];
    } catch (error) {
        return [];
    }
}

export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState(loadStoredCart);

    useEffect(() => {
        localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cartItems));
    }, [cartItems]);

    // Función para añadir un producto al carrito
    const addToCart = (product) => {
        setCartItems((prevItems) => {
            const itemInCart = prevItems.find((item) => item.id === product.id);
            if (itemInCart) {
                return prevItems.map((item) =>
                    item.id === product.id
                        ? { ...item, quantity: item.quantity + 1 }
                        : item
                );
            } else {
                return [...prevItems, { ...product, quantity: 1 }];
            }
        });
    };

    // Función para eliminar un producto del carrito
    const removeFromCart = (product) => {
        setCartItems((prevItems) =>
            prevItems.filter((item) => item.id !== product.id)
        );
    };

    // Función para actualizar la cantidad de productos
    const updateQuantity = (product, quantity) => {
        setCartItems((prevItems) =>
            prevItems.map((item) =>
                item.id === product.id ? { ...item, quantity } : item
            )
        );
    };

    return (
        <CartContext.Provider value={{ cartItems, addToCart, removeFromCart, updateQuantity }}>
            {children}
        </CartContext.Provider>
    );
};
